export function setImmediateInterval(fn, delay) {
  fn()
  return setInterval(fn, delay)
}
